export const SECTION_TYPES = [
  "hero",
  "text-block",
  "cards",
  "slider",
  "gallery",
  "video",
  "faq",
  "downloads",
  "contact-info",
  "custom",
];

export const LANGUAGES = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "ar", label: "Arabic", dir: "rtl" },
  { code: "ku", label: "Kurdish", dir: "rtl" },
];
